import { ReactElement } from 'react'
import { NextTime } from './styles'
import { Text } from '@raskrask-dk/rr-components'
import { PropsPartnerCardText } from './props'

const PartnerCardText = ({
    t,
    firstAVTime,
    timeSlots,
}: PropsPartnerCardText): ReactElement => {
    // const [BFSM] = useBFSM()

    // const shouldShowTimeslots = BFSM.canDo(CalendarActions.SetTime)
    if (timeSlots.length > 0) {
        const timeStamps = [
            {
                arg: (time: string) => '12:00' >= time,
                text: 'morning',
            },
            {
                arg: (time: string) => '11:00' <= time && '17:00' >= time,
                text: 'noon',
            },
            {
                arg: (time: string) => '17:00' <= time,
                text: 'evening',
            },
        ]

        return (
            <>
                {timeStamps.map((timeStamp, key) => {
                    const active = timeSlots.findIndex(timeStamp.arg) !== -1
                    // const active = true // TODO

                    return (
                        <Text key={key} bold={active} lighter={!active}>
                            {t(`common:${timeStamp.text}`)}
                        </Text>
                    )
                })}
            </>
        )
    }
    return (
        <>
            <NextTime bold primary>
                {t('calendar.partnercards.nexttime')}
            </NextTime>
            <Text primary>{firstAVTime?.toString('EEE d/M')}</Text>
            <Text primary>{firstAVTime?.toString('HH:mm')}</Text>
        </>
    )
}

export default PartnerCardText
